// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//多处用到的组件
import defaultIcon from '@/components/todoCenter/defaultIcon'
import collect from '@/components/todoCenter/collect'
import bannerImg from '@/components/todoCenter/bannerImg'
import ProcessPass from '@/components/todoCenter/process'
import Logo from '@/components/todoCenter/logo'
import PjModal from '@/components/todoCenter/pjmodal'

import { DropdownMenu, DropdownItem, Popup, Cell, Calendar,RadioGroup, Radio,Form,Field,Button } from 'vant';
import 'vant/lib/index.css';

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(Calendar)

Vue.use(Form)
Vue.use(Field)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Button)






// import './aiDialog/css/aiDialog.css'
import VueApollo from 'vue-apollo'
import apolloProvider from './apolloConfig'
Vue.use(VueApollo);

import axios from './axiosConfig'
//人工智能
// import aiDialog from './aiDialog/js/aiDialog.js'
Vue.prototype.$axios=axios;


Vue.prototype.$getShowOrHidden = function(name, process){
  // console.log(process)
  let code = process.app.code;
  if(['CY_CSIframe', 'XZXXA', 'WBJSXFKQD'].includes(code)){
    return '**'
  }else{
    return name
  }
  
}

Vue.config.productionTip = false

//定义一些全局组件
Vue.component('defaultIcon',defaultIcon);
Vue.component('collect',collect);
Vue.component('bannerImg',bannerImg);
Vue.component('ProcessPass',ProcessPass);
Vue.component('Logo',Logo);
Vue.component('PjModal',PjModal);


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import ant from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
// import 'ant-design-vue/dist/antd.less'
Vue.use(ant);

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  data:function(){
    return {
      userName:"8980u0hp0",
      account:"",
    }
  },
  router,
  store,
  provide: apolloProvider.provide(),
  render: h=>h(App)
  // template: '<mobile/>'
})
export default vue


// WEBPACK FOOTER //
// ./src/main.js